import FakeCollection from "./fakeCollection";
import { alertsSample } from "./data/alertsSample";
import { getZones, getSensors, getBoxs } from "./project";

const alertsCollection = new FakeCollection("fk_alerts", alertsSample);

export const getAlerts = () => {
  let alertsList = alertsCollection.get();
  let zones = getZones();

  let alerts = zones.map((zone) => {
    let zoneBoxs = getBoxs(zone.id);
    let boxSensors = zoneBoxs
      .map((item) => {
        let sensors = getSensors(item.id);
        return sensors.map((item) => {
          return {
            ...item,
            boxDesignation: item.designation,
          };
        });
      })
      .flat();
    let sensorsIds = boxSensors.map((item) => item.id);

    var obj = {
      zone: zone.designation,
      zoneId: zone.id,
      alerts: alertsList.filter((item) => {
        return sensorsIds.indexOf(item.sensorId) > -1;
      }),
    };

    obj.alerts = obj.alerts.map((alert) => {
      var sensor = boxSensors.find(
        (item) => item.id === alert.sensorId
      );

      return {
        ...alert,
        boxId: sensor.boxId,
        boxDesignation: sensor.boxDesignation,
        sensorDesignation: sensor.designation,
      };
    });
    return obj;
  });
  return alerts;
};

export const addAlert = (
  sensorId,
  designation,
  severity,
  type,
  value,
  active
) => {
  return alertsCollection.add({
    sensorId,
    designation,
    severity,
    type,
    value,
    active,
  });
};

export const updateAlert = (
  id,
  sensorId,
  designation,
  severity,
  type,
  value,
  active
) => {
  return alertsCollection.add({
    id,
    sensorId,
    designation,
    severity,
    type,
    value,
    active,
  });
};

export const activateAlert = (id, active) => {
  console.log('....activateAlert: %o', {id, active});
  return alertsCollection.add({ ...alertsCollection.get(id), active });
};

export const removeAlert = (id) => {
  return alertsCollection.remove(id);
};
